import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "checkout-page__form-container"
}
const _hoisted_2 = { class: "checkout-page__inner-container checkout-page__inner-container--header" }
const _hoisted_3 = { class: "checkout-page__header" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "checkout-page__form-inner-container checkout-page__inner-container checkout-payment-form" }
const _hoisted_6 = { class: "checkout-page__form-header" }
const _hoisted_7 = { class: "checkout-page__payment-methods" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "checkout-page__payment-method-info-container" }
const _hoisted_10 = { class: "checkout-page__payment-methods-item__header" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "checkout-alternatives-form" }
const _hoisted_16 = { class: "checkout-page__alternatives" }
const _hoisted_17 = { class: "checkout-page__alternative" }
const _hoisted_18 = { for: "hasComment" }
const _hoisted_19 = { class: "checkout-page__alternative-header" }
const _hoisted_20 = { class: "checkout-page__alternative-description" }
const _hoisted_21 = { class: "checkout-page__alternative-comment" }
const _hoisted_22 = { class: "checkout-page__alternative checkout-page__alternative--tos" }
const _hoisted_23 = { class: "checkout-page__alternative-description" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "checkout-page__form-button-container checkout-page__form-button-container--delivery" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "checkout-page__minimum-amount-alert__title" }

import dictionary from "@/i18n/dictionary.json";
import { computed, onMounted, PropType, ref, watch } from "vue";
import TressRadioInput from "@/components/TressRadioInput.vue";
import TressAlert from "@/components/TressAlert.vue";
import TressCheckboxInput from "@/components/TressCheckboxInput.vue";
import TressTextAreaInput from "@/components/TressTextAreaInput.vue";
import TressOrderSummary from "@/components/TressOrderSummary.vue";
import { CheckoutApi } from "@/services/Api";
import { IPaymentMethodItem, PlaceOrderCommand } from "@/models/Checkout";
import { ICheckoutAddresses } from "@/models/ICheckoutAddresses";
import TressCheckoutCustomerDataForm from "@/components/TressCheckoutCustomerDataForm.vue";
import TressCheckoutDeliveryForm from "@/components/TressCheckoutDeliveryForm.vue";
import { Checkout, IPaymentMethod, ShippingOption } from "@/models/Checkout";
import { useCart } from "@/store/useCart";
import { useCheckout } from "@/store/useCheckout";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import { useSpinner } from "@/services/Spinner";
import { DataLayerApi } from "@/services/Api";

const invoicePaymentMethodId = "129";

export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheCheckout',
  props: {
  isLoggedIn: {
    type: Boolean,
    required: false,
    default: false,
  },
  addresses: {
    type: Object as PropType<ICheckoutAddresses>,
    required: true,
  },
  alwaysShowFreightFee: {
    type: Boolean,
  },
  showAsB2b: {
    type: Boolean,
    required: true,
  },
  loginPageUrl: {
    type: String,
    required: true,
  },
  hasSelectedDeliveryMethod: {
    type: Boolean,
    required: true,
  },
  paymentMethods: {
    type: Array as PropType<Array<IPaymentMethod>>,
    required: true,
  },
  policyPage: {
    type: String,
  },

},
  setup(__props) {

const props = __props;

const model = useCheckout();
const checkoutPageRef = ref<HTMLElement | undefined>(undefined);
const spinner = ref();

DataLayerApi.createBeginCheckoutEvent();

onMounted(async () => {
  spinner.value = useSpinner();

  if (!props.hasSelectedDeliveryMethod) {
    model.clearDeliveryMethod();
  }
});



const hasAcceptedTos = ref(false);
const basket = useCart();
const deliveryMethods = ref<Array<ShippingOption>>([]);
const hasComment = ref<boolean>(!!model.comment);
const { t } = useI18n();
const isStep2Touched = ref<boolean>(false);
const isStep3Touched = ref<boolean>(false);
const openAccordionId = ref<string>("step1");
const openAccordionHeight = ref<string | number>("auto");
const openAccordion = (id: string) => {
  const filterEl = document.getElementById(id);
  openAccordionId.value = id;
  if (openAccordionHeight.value == 0) {
    if (filterEl) {
      openAccordionHeight.value = `${filterEl.scrollHeight}px`;
      setTimeout(() => {
        openAccordionHeight.value = "auto";
      }, 300);
    }
  } else {
    if (filterEl) {
      openAccordionHeight.value = `${filterEl.scrollHeight}px`;
      setTimeout(() => {
        openAccordionHeight.value = "0";
      }, 10);
    }
  }
};
const onChangeStep = (id: string) => {
  openAccordion(id);
};
const zipCode = ref<string>();
const isLoading = ref<boolean>(false);
const onPreSubmit = () => {
  isLoading.value = true;
  spinner.value.spin();
};
const onSubmitFail = () => {
  isLoading.value = false;
  spinner.value.stop();
};

const onStep1Click = async () => {
  isLoading.value = false;
  spinner.value.stop();
  openAccordion("step2");
  isStep2Touched.value = true;
};

const onStep2Click = async (checkout: Checkout) => {
  await basket.set(checkout.basket);
  openAccordion("step3");
  isStep3Touched.value = true;
};
const sendForm = async () => {
  try {
    const command: PlaceOrderCommand = {
      comment: model.comment,
      paymentMethodId: model.paymentMethodId,
    };
    const redirect = await CheckoutApi.placeOrder(command);
    window.location.href = redirect;
  } catch (e: unknown) {
    console.error(e);
    await Swal.fire<void>({
      icon: "error",
      text: t(dictionary.checkout.executePaymentFailed),
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "btn btn-success button button--default",
      },
      buttonsStyling: false,
    });
  }
};
const onCustomerDataFormSubmit = async () => {
  await onStep1Click();
};
const formIsValid = computed(() => {
  return !!model.paymentMethodId && !!model.deliveryMethodId && hasAcceptedTos.value;
});

const getPaymentItemNames = (paymentItems: Array<IPaymentMethodItem>) => {
  if (paymentItems) {
    return paymentItems.map((x) => x.name).join(", ");
  }
  return null;
};

watch(
  () => model.deliveryMethodId,
  (currentValue: string) => {
    if (!currentValue) {
      openAccordion("step2");
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("section", {
    ref_key: "checkoutPageRef",
    ref: checkoutPageRef,
    class: "checkout-page"
  }, [
    (_unref(basket).id && _unref(basket).reachedMinimumBuyableAmount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.headline)), 1)
          ]),
          (!__props.isLoggedIn)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 0,
                class: "checkout-page__login-alert",
                success: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.alreadyHaveAnAccount)) + " ", 1),
                    _createElementVNode("a", { href: __props.loginPageUrl }, _toDisplayString(_ctx.$t(_unref(dictionary).form.loginHere)), 9, _hoisted_4)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(TressCheckoutCustomerDataForm, {
            addresses: __props.addresses,
            "is-logged-in": __props.isLoggedIn,
            "open-accordion-height": openAccordionHeight.value,
            "open-accordion-id": openAccordionId.value,
            onEdit: _cache[0] || (_cache[0] = ($event: any) => (onChangeStep('step1'))),
            onSubmit: onCustomerDataFormSubmit,
            onPreSubmit: onPreSubmit,
            onSubmitFail: onSubmitFail
          }, null, 8, ["addresses", "is-logged-in", "open-accordion-height", "open-accordion-id"]),
          _createVNode(_component_v_form, {
            "initial-values": {
          comment: _unref(model).comment,
          hasComment: hasComment.value ? 'on' : '',
          deliverymethod: _unref(model).deliveryMethodId,
          paymentMethod: _unref(model).paymentMethodId,
        }
          }, {
            default: _withCtx(() => [
              _createVNode(TressCheckoutDeliveryForm, {
                "delivery-methods": deliveryMethods.value,
                "is-form-touched": isStep2Touched.value,
                "open-accordion-height": openAccordionHeight.value,
                "open-accordion-id": openAccordionId.value,
                onEdit: _cache[1] || (_cache[1] = ($event: any) => (onChangeStep('step2'))),
                onSubmit: onStep2Click,
                "zip-code": zipCode.value,
                "show-as-b2b": __props.showAsB2b
              }, null, 8, ["delivery-methods", "is-form-touched", "open-accordion-height", "open-accordion-id", "zip-code", "show-as-b2b"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.step3)), 1),
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.paymentMethods, (paymentMethodModel, idx) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: idx,
                      for: paymentMethodModel.id,
                      class: "checkout-page__payment-methods-item"
                    }, [
                      _createVNode(TressRadioInput, {
                        id: paymentMethodModel.id,
                        modelValue: _unref(model).paymentMethodId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).paymentMethodId) = $event)),
                        value: paymentMethodModel.id,
                        class: "checkout-page__payment-method-input",
                        name: "paymentMethod",
                        rules: "required"
                      }, null, 8, ["id", "modelValue", "value"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, [
                          (paymentMethodModel.id == '14' && __props.showAsB2b)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.cardb2b)), 1))
                            : (paymentMethodModel.id == '14')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.card)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(getPaymentItemNames(paymentMethodModel.items)), 1))
                        ]),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethodModel.items, (paymentMethod) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: paymentMethod.id,
                              class: "checkout-page__payment-method"
                            }, [
                              (paymentMethod.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: paymentMethod.imageUrl,
                                    class: "checkout-page__payment-method-logo"
                                  }, null, 8, _hoisted_14))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 8, _hoisted_8))
                  }), 128)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _createVNode(TressCheckboxInput, {
                            id: "hasComment",
                            modelValue: hasComment.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hasComment).value = $event)),
                            name: "hasComment"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("label", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.iHaveACommentForMyOrder)), 1),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.iHaveACommentDisclaimer)), 1)
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_21, [
                        _createVNode(TressTextAreaInput, {
                          modelValue: _unref(model).comment,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).comment) = $event)),
                          label: "comment",
                          name: "comment",
                          maxlength: 100
                        }, null, 8, ["modelValue"])
                      ], 512), [
                        [_vShow, hasComment.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", null, [
                        _createVNode(TressCheckboxInput, {
                          id: "hasAcceptedTos",
                          modelValue: hasAcceptedTos.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((hasAcceptedTos).value = $event)),
                          name: "hasAcceptedTos"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.hasAcceptedPrivacyPolicy)) + " ", 1),
                        _createElementVNode("a", {
                          href: __props.policyPage,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t(_unref(dictionary).form.here)), 9, _hoisted_24)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      disabled: !formIsValid.value,
                      class: "checkout-page__form-button",
                      type: "button",
                      onClick: sendForm
                    }, [
                      (_unref(model).paymentMethodId === invoicePaymentMethodId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).checkout.finishOrder)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).checkout.goToPayment)), 1)
                          ], 64))
                    ], 8, _hoisted_26)
                  ])
                ], 512), [
                  [_vShow, openAccordionId.value == 'step3']
                ])
              ])
            ]),
            _: 1
          }, 8, ["initial-values"])
        ]))
      : _createCommentVNode("", true),
    (_unref(basket).id)
      ? (_openBlock(), _createBlock(TressOrderSummary, {
          key: 1,
          "always-show-freight-fee": __props.alwaysShowFreightFee,
          class: "checkout-page__order-summary-container"
        }, null, 8, ["always-show-freight-fee"]))
      : _createCommentVNode("", true),
    (!_unref(basket).id)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_27, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.emptyBasket)), 1))
      : _createCommentVNode("", true),
    (!_unref(basket).reachedMinimumBuyableAmount)
      ? (_openBlock(), _createBlock(TressAlert, {
          key: 3,
          class: "checkout-page__minimum-amount-alert",
          success: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(__props.showAsB2b ? _ctx.$t(_unref(dictionary).checkout.minimumAmountTitleB2B) : _ctx.$t(_unref(dictionary).checkout.minimumAmountTitleB2C)), 1),
              _createTextVNode(" " + _toDisplayString(_unref(basket).minimumBuyableAmountMessage), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})